/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateOrUpdateTaskItemAreaDto } from './CreateOrUpdateTaskItemAreaDto';
import {
    CreateOrUpdateTaskItemAreaDtoFromJSON,
    CreateOrUpdateTaskItemAreaDtoFromJSONTyped,
    CreateOrUpdateTaskItemAreaDtoToJSON,
} from './CreateOrUpdateTaskItemAreaDto';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface CopyTaskItemAreaDto
 */
export interface CopyTaskItemAreaDto {
    /**
     * 
     * @type {string}
     * @memberof CopyTaskItemAreaDto
     */
    targetSystemId?: string;
    /**
     * 
     * @type {CreateOrUpdateTaskItemAreaDto}
     * @memberof CopyTaskItemAreaDto
     */
    area?: CreateOrUpdateTaskItemAreaDto;
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof CopyTaskItemAreaDto
     */
    taskType?: TaskTypeDescription;
    /**
     * 
     * @type {string}
     * @memberof CopyTaskItemAreaDto
     */
    $type?: CopyTaskItemAreaDtoTypeEnum;
}


/**
 * @export
 */
export const CopyTaskItemAreaDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoCopyTaskItemAreaDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.CopyTaskItemAreaDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CopyTaskItemAreaDtoTypeEnum = typeof CopyTaskItemAreaDtoTypeEnum[keyof typeof CopyTaskItemAreaDtoTypeEnum];



/**
 * Check if a given object implements the CopyTaskItemAreaDto interface.
 */
export function instanceOfCopyTaskItemAreaDto(value?: unknown): value is CopyTaskItemAreaDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CopyTaskItemAreaDtoTypeEnum)[0];
}

export function CopyTaskItemAreaDtoFromJSON(json: any): CopyTaskItemAreaDto {
    return CopyTaskItemAreaDtoFromJSONTyped(json, false);
}

export function CopyTaskItemAreaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopyTaskItemAreaDto {
    if (json == null) {
        return json;
    }
    return {
        
        'targetSystemId': json['targetSystemId'] == null ? undefined : json['targetSystemId'],
        'area': json['area'] == null ? undefined : CreateOrUpdateTaskItemAreaDtoFromJSON(json['area']),
        'taskType': json['taskType'] == null ? undefined : TaskTypeDescriptionFromJSON(json['taskType']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CopyTaskItemAreaDtoToJSON(value?: CopyTaskItemAreaDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'targetSystemId': value['targetSystemId'],
        'area': CreateOrUpdateTaskItemAreaDtoToJSON(value['area']),
        'taskType': TaskTypeDescriptionToJSON(value['taskType']),
        '$type': value['$type'],
    });
}

